// src/lib/api.js
// Central place for backend API calls. Update BASE_URL to your live domain.

export const BASE_URL = "https://aishcraft.com/backend/api";

const TOKEN_KEY = "aishcraft_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * apiFetch("/auth/login.php", { method:"POST", body:{email,password} })
 * Automatically attaches Bearer token (if present) and parses JSON.
 * Supports both plain JS objects (sent as JSON) and FormData (sent as multipart, for file uploads).
 * Throws an Error with .message on failure so callers can catch().
 */
export async function apiFetch(path, { method = "GET", body, auth = true } = {}) {
  const isFormData = body instanceof FormData;

  const headers = {};
  if (!isFormData) {
    // Only set JSON content-type for plain object bodies.
    // For FormData, let the browser set "multipart/form-data; boundary=..." itself.
    headers["Content-Type"] = "application/json";
  }
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error("Server returned an invalid response.");
  }

  if (!res.ok || data.success === false) {
    // Auto-logout on expired/invalid session
    if (res.status === 401) clearToken();
    throw new Error(data.message || "Something went wrong.");
  }

  return data;
}